var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patentStructure"},[_c('el-dialog',{attrs:{"title":"专利发明结构图","visible":_vm.visible,"width":"60vw"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('StructureTree')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }